if ($("#identification-tool").length) {
  require("./identifier");
}

if ($("#fact-sheet").length) {
  require("./factsheet");
}
